import React, { useState } from 'react';
import HomeTabIcon from '../Icons/HomeTabIcon';
import ChatTabIcon from '../Icons/ChatTabIcon';

const Tabs = ({
  homeTabName = 'Home',
  chatTabName = 'Chat',
  activeTab = 'home', // 'home' or 'chat'
  onTabChange,
  className = '',
  showWhiteBackground = false, // New prop to control white background
  tabOrder = { home: 1, chat: 2 }, // Default order
  config, // Add config prop for styling
  ...props
}) => {
  const [hoveredTab, setHoveredTab] = useState(null);

  // Create ordered tabs array based on order configuration
  const getOrderedTabs = () => {
    const tabs = [
      { id: 'home', name: homeTabName, order: tabOrder.home },
      { id: 'chat', name: chatTabName, order: tabOrder.chat }
    ];
    return tabs.sort((a, b) => a.order - b.order);
  };

  const orderedTabs = getOrderedTabs();

  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  const getTabState = (tab) => {
    if (activeTab === tab) return 'selected';
    if (hoveredTab === tab) return 'hover';
    return 'not-selected';
  };

  const getLabelClasses = (tab) => {
    const baseClasses = 'text-center font-inter-variable text-base leading-6';
    if (activeTab === tab) {
      return `${baseClasses} font-bold`;
    }
    if (hoveredTab === tab) {
      return `${baseClasses} font-regular`;
    }
    return `${baseClasses} font-regular`;
  };

  const getLabelStyle = (tab) => {
    const baseStyle = {
      fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
      fontSize: config?.font_size ? `${config.font_size}px` : undefined,
    };

    if (activeTab === tab || hoveredTab === tab) {
      return {
        ...baseStyle,
        color: config?.element_color || 'var(--v3-black-heading)',
      };
    }
    return {
      ...baseStyle,
      color: config?.element_color ? `${config.element_color}80` : 'var(--v3-black-secondary)', // 50% opacity for inactive
    };
  };

  const renderTabButton = (tab) => {
    const isHome = tab.id === 'home';
    const Icon = isHome ? HomeTabIcon : ChatTabIcon;

    return (
      <button
        key={tab.id}
        className="flex h-20 flex-col justify-center  items-center gap-1 flex-1"
        onClick={() => handleTabClick(tab.id)}
        onMouseEnter={() => setHoveredTab(tab.id)}
        onMouseLeave={() => setHoveredTab(null)}
      >
        <Icon state={getTabState(tab.id)} config={config} />
        <span
          className={getLabelClasses(tab.id)}
          style={getLabelStyle(tab.id)}
        >
          {tab.name}
        </span>
      </button>
    );
  };

  return (
    <div
      className={`flex w-full justify-between items-center shadow-v3-card-wrapper relative z-10 ${config?.remove_watermark ? 'border-none' : `border-b`} ${(!config?.remove_watermark && config?.element_color) ? '' : (!config?.remove_watermark && config?.surface_color ? `border-b-${config.surface_color}` : (!config?.remove_watermark ? 'border-v3-black-card' : ''))} ${className}`}
      style={
        (!config?.remove_watermark && config?.surface_color)
          ? { borderBottom: `1px solid ${config.surface_color}` }
          : undefined
      }
      {...props}
    >
      {orderedTabs.map(tab => renderTabButton(tab))}
    </div>
  );
};

export default Tabs;
